import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ItemSelectSiswa } from "../item";
import useClickOutside from "../../hooks/useClickOutside";

export default function SelectMultiple({
  dataSiswa,
  selectedSiswa,
  handleChange,
  selectedAll,
}) {
  const { t } = useTranslation();
  const [openPopup, setOpenPopup] = useState(false);
  const [siswa, setSiswa] = useState([]);
  const cekSelected = (id) => {
    if (selectedAll) return true;
    return selectedSiswa.includes(id.toString());
  };
  const renderValue = () => {
    const result = selectedSiswa
      .map((id) => {
        const selectedOption = dataSiswa.find(
          (item) => item.user.user_id.toString() === id.toString()
        );
        return selectedOption?.user?.user_nama;
      })
      .filter(Boolean);
    setSiswa(result);
  };
  useEffect(() => {
    if (selectedSiswa.length > 0) {
      renderValue();
    } else {
      setSiswa([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSiswa, dataSiswa]);
  const dropdownRef = useClickOutside(() => {
    setOpenPopup(false);
  });

  return (
    <div ref={dropdownRef} className="w-100 position-relative">
      <div className="w-100">
        <p className="mb-2">
          {t("pilih_params", { params: t("siswa") })}{" "}
          <span className="text-danger">*</span> :
        </p>
        <div
          onClick={() => setOpenPopup(!openPopup)}
          className="d-flex align-items-center justify-content-between select-multiple form-control cursor-pointer user-select-none"
        >
          <div className="d-flex flex-1 overflow-hidden">
            <div className="value">
              {siswa?.length > 0
                ? siswa?.join(", ")
                : t("pilih_params", { params: t("siswa") })}
            </div>
          </div>
          <i
            className="fa fa-chevron-down"
            aria-hidden="true"
            style={{ fontSize: 10 }}
          ></i>
        </div>
      </div>
      <div
        className={`w-100 bg-white py-3 px-1 mt-2 popup-select-multiple ${
          openPopup ? "position-absolute" : "d-none"
        }`}
        style={{ zIndex: 10000 }}
      >
        <h5 className="fw-bold mb-2 px-3">
          {t("pilih_params", { params: t("siswa") })}
        </h5>
        <ul
          className="todo-task-lists m-0 p-0 overflow-auto"
          style={{ maxHeight: 200 }}
        >
          <ItemSelectSiswa
            nama={t("pilih_semua")}
            selected={selectedAll}
            code="all"
            handleChange={() => handleChange("all", !selectedAll)}
          />
          {dataSiswa?.length <= 0 ? (
            <li className="text-center">
              {t("data_params_kosong", { params: t("siswa") })}
            </li>
          ) : (
            dataSiswa?.map((item) => (
              <ItemSelectSiswa
                key={item?.user?.user_id}
                img={item?.user?.user_avatar}
                nama={item?.user?.user_nama}
                selected={cekSelected(item?.user?.user_id?.toString())}
                handleChange={handleChange}
                code={item?.user?.user_id}
              />
            ))
          )}
        </ul>
      </div>
    </div>
  );
}
